import cn from 'classnames';
import { SliderProps } from './slider.props';
import styles from './slider.module.scss';

export const Slider = ({
  offsetBy,
  className,
  children,
}: SliderProps): JSX.Element => {
  const moduleStyles = cn(styles.module, className);

  return (
    <div className={moduleStyles}>
      <div className={styles.wrapper} style={{ left: `${offsetBy * -100}%` }}>
        {children}
      </div>
    </div>
  );
};
